/**
 * @generated SignedSource<<70799d332cc88da375b215c119f725c3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FileStatus = "ERROR" | "PENDING" | "PROCESSING" | "READY" | "WAIT_FOR_PROCESSING";
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
export type PreviewWidgetFileInput = {
  files?: ReadonlyArray<FileInput> | null;
  size?: WidgetOverviewSize | null;
  storecastId?: string | null;
};
export type FileInput = {
  fileId: string;
  pageNumbers?: ReadonlyArray<number> | null;
};
export type WAFileAddMockPreviewQuery$variables = {
  input: PreviewWidgetFileInput;
  storecastId: string;
};
export type WAFileAddMockPreviewQuery$data = {
  readonly dashboard: {
    readonly previewWidgetFile: {
      readonly " $fragmentSpreads": FragmentRefs<"WidgetFile_widgetFile">;
    };
  };
};
export type WAFileAddMockPreviewQuery$rawResponse = {
  readonly dashboard: {
    readonly id: string;
    readonly previewWidgetFile: {
      readonly files: ReadonlyArray<{
        readonly file: {
          readonly id: string;
          readonly name: string | null;
          readonly status: FileStatus;
        };
        readonly pages: ReadonlyArray<{
          readonly id: string;
          readonly image: {
            readonly id: string;
            readonly sizes: ReadonlyArray<{
              readonly height: number;
              readonly id: string;
              readonly url: string;
              readonly urlExpiresAt: string | null;
              readonly width: number;
            }>;
            readonly thumbhash: string | null;
          } | null;
        }>;
      }>;
      readonly id: string;
      readonly slideshowDuration: number | null;
      readonly title: string;
    };
  } | null;
};
export type WAFileAddMockPreviewQuery = {
  rawResponse: WAFileAddMockPreviewQuery$rawResponse;
  response: WAFileAddMockPreviewQuery$data;
  variables: WAFileAddMockPreviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storecastId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "storecastId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WAFileAddMockPreviewQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*: any*/),
          "concreteType": "Dashboard",
          "kind": "LinkedField",
          "name": "dashboard",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": (v2/*: any*/),
              "concreteType": "WidgetFile",
              "kind": "LinkedField",
              "name": "previewWidgetFile",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WidgetFile_widgetFile"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WAFileAddMockPreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Dashboard",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "WidgetFile",
            "kind": "LinkedField",
            "name": "previewWidgetFile",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "WidgetFileEdge",
                "kind": "LinkedField",
                "name": "files",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "File",
                    "kind": "LinkedField",
                    "name": "file",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FilePage",
                    "kind": "LinkedField",
                    "name": "pages",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "image",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "thumbhash",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ImageSize",
                            "kind": "LinkedField",
                            "name": "sizes",
                            "plural": true,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "url",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "urlExpiresAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "height",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "width",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slideshowDuration",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "171f01b489e236bad26bd38880b34978",
    "id": null,
    "metadata": {},
    "name": "WAFileAddMockPreviewQuery",
    "operationKind": "query",
    "text": "query WAFileAddMockPreviewQuery(\n  $input: PreviewWidgetFileInput!\n  $storecastId: ID!\n) {\n  dashboard(id: $storecastId) {\n    previewWidgetFile(input: $input) {\n      ...WidgetFile_widgetFile\n      id\n    }\n    id\n  }\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment WidgetFileDynamic_widgetFile on WidgetFile {\n  ...WidgetFileStatic_widgetFile\n  id\n  title\n  files {\n    pages {\n      id\n      ...WidgetFilePage_page\n    }\n    file {\n      id\n      status\n      ...WidgetFilePageProcessing_file\n      name\n    }\n  }\n}\n\nfragment WidgetFilePageProcessing_file on File {\n  status\n}\n\nfragment WidgetFilePage_page on FilePage {\n  id\n  image {\n    id\n    ...Image_image\n  }\n}\n\nfragment WidgetFileStatic_widgetFile on WidgetFile {\n  id\n  title\n  slideshowDuration\n  files {\n    pages {\n      id\n      ...WidgetFilePage_page\n    }\n    file {\n      id\n      status\n      ...WidgetFilePageProcessing_file\n      name\n    }\n  }\n}\n\nfragment WidgetFile_widgetFile on WidgetFile {\n  id\n  files {\n    file {\n      id\n      status\n    }\n  }\n  ...WidgetFileStatic_widgetFile\n  ...WidgetFileDynamic_widgetFile\n}\n"
  }
};
})();

(node as any).hash = "c7713edf6304586a06cc2321b6caeb03";

export default node;
